var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 24",
    id: "html",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.95 7.035.24-2.625h-13.261l.705 8.01h9.18l-.33 3.42-2.955.795-2.94-.795-.195-2.1h-2.625l.33 4.17 5.43 1.5h.06v-.015l5.385-1.485.75-8.16h-9.66l-.225-2.715zm-16.95-7.035h21.12l-1.92 21.57-8.67 2.43-8.61-2.43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.b20bdf9f891632bb1f6e065777b53388.svg";
export { ForwardRef as ReactComponent };